import styled from '@emotion/styled';
import { Flex, Timeline, TimelineItemProps, Typography } from 'antd';
import { FC } from 'react';

import { TimelineDotIcon } from '../Icon';

/**
 * Styled container for the timeline with custom positioning
 */
const TimelineContainer = styled.div`
  padding: 0 12px;
  & .ant-timeline {
    .ant-timeline-item {
      .ant-timeline-item-label {
        width: unset;
      }
      .ant-timeline-item-head-custom,
      .ant-timeline-item-tail {
        inset-inline-start: 90px;
      }
      .ant-timeline-item-content {
        width: calc(100% - 110px);
        inset-inline-start: 100px;
      }
      .ant-timeline-item-head.ant-timeline-item-head-custom {
        background: #fafafa;
      }
    }
    .ant-timeline-item-last > .ant-timeline-item-content {
      min-height: unset;
    }
  }
`;

interface Props {
  data: TimelineItemProps[]; // Array of timeline items
  date: string; // Date header for the timeline group
}

/**
 * A timeline component for displaying chronological logs/events with:
 * - Custom styling and layout
 * - Date grouping
 * - Consistent visual design
 */
export const TimelineLogs: FC<Props> = ({ data, date }) => {
  const items = data.map((item) => ({
    ...item,
    label: (
      <Typography.Text className="pr-4 text-gray-500">
        {item.label}
      </Typography.Text>
    ),
    dot: <TimelineDotIcon />, // Custom icon for all timeline dots
  }));

  return (
    <Flex
      vertical
      className="border border-gray-200 rounded-md p-4 bg-gray-50"
      gap={16}
    >
      {/* Date header for the timeline group */}
      <Typography.Text className="text-base font-semibold text-gray-700">
        {date}
      </Typography.Text>
      {/* Timeline container with custom styling */}
      <TimelineContainer>
        <Timeline mode="left" items={items} />
      </TimelineContainer>
    </Flex>
  );
};
